import {
  UPDATE_MANAGER_SHIFT_SUCCESS,
  DELETE_MANAGER_SHIFT_SUCCESS,
  ADD_MANAGER_SHIFT_SUCCESS,
  ADD_WEEK_PLANNER_SUCCESS
} from "../Constants";

const initialState = {
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_SHIFT_SUCCESS:
      return {
        type: "updateShiftSuccess",
        message: action.data
      };
    case DELETE_MANAGER_SHIFT_SUCCESS:
      return {
        type: "deleteShiftSuccess",
        message: action.data
      };
    case ADD_MANAGER_SHIFT_SUCCESS:
      return {
        type: "addShiftSuccess",
        message: action.data
      };
    case ADD_WEEK_PLANNER_SUCCESS:
      return {
        type: "addShiftSuccess",
        message: action.data
      };
    default:
      return state;
  }
};
